



















export default

	# Messages can be passed as a simple string, an HTML string, an array of
	# simple strings, an AggregateError instance or a  Error instance
	props: messages: String | Array | Object

	computed:

		# Format messages into an HTML string if they are an array
		messagesHtml: -> switch

			# Text messages
			when typeof @messages == 'string' then switch

				# Passthrough HTML
				when @messages.includes '</' then @messages

				# Support simple strings
				else @messageArrayToHtml [ @messages ]

			# An array of message strings
			when typeof @messages == 'array' and @messages.length
			then @messageArrayToHtml @messages

			# Support errors
			when typeof @messages == 'object' then switch

				# Support AggregateError as messages
				when @messages instanceof AggregateError
				then @messageArrayToHtml @messages.errors

				# Support single standard error
				when @messages instanceof Error
				then @messageArrayToHtml [ @messages.message ]

	methods:

		# Convert an array of message strings to an HTML list
		messageArrayToHtml: (messages) ->
			list = messages.map (message) -> "<li>#{message}</li>"
			"<ul>#{list.join(" ")}</ul>"


